import { SelectField } from "$components/inputs";
import React from "react";
import { useController } from "react-hook-form";

export const RHFSelectField: FC<React.ComponentProps<typeof SelectField>> = ({
  name,
  ...restProps
}): React.ReactElement => {
  const controller = useController({ name });
  return (
    <SelectField
      {...controller.field}
      // We set "" here instead of as the default value to the controller so that the forms
      // aren't forced to hold "" values, which can be problematic for validation,
      // but MUI is satisfied that the component is controlled on first render.
      value={controller.field.value ?? ""}
      error={controller.fieldState.error?.message}
      {...restProps}
    />
  );
};
